import { ORMCommonState } from 'redux-orm';
import { orm } from '../orm';

export const INITIAL_ORM_STATE: ORMCommonState = orm.getEmptyState();
